export default "__VITE_ASSET__eb4fe3cf__"